<template>
<div>

  <v-btn fab fixed right bottom dark color="accent" @click="dialogLink=true">
    <v-icon>mdi-plus</v-icon>
  </v-btn>

  <LinkDeviceHint :visible="hint"></LinkDeviceHint>

  <LinkDeviceDialog v-model="dialogLink" :user="user"></LinkDeviceDialog>

</div>
</template>

<script>
import LinkDeviceHint from '@/components/hint/LinkDeviceHint'
import LinkDeviceDialog from '@/components/dialog/LinkDeviceDialog'

export default {
  name: 'AddDeviceButton',
  components: {
    LinkDeviceHint,
    LinkDeviceDialog
  },
  props: {
    hint: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogLink: false
    }
  }
}
</script>
